module.exports = __webpack_public_path__ + "static/img/rank-1.dcfa5d1c.svg";